export const SOFT_FEEDBACK_CONTROLLER = {
  // 增删改查
  softFeedback: "/api/v1/soft-feedback",
};
